module.exports = __webpack_public_path__ + "static/img/mall-bg.56688422.png";